import React, { memo } from "react";

import * as S from "./social-icons.styles";
import Icon from "./icons";

export const SocialLinks = ({ links }) => (
  <S.SocialList>
    {links.map(({ icon, link }, idx) => (
      <S.SocialItem key={`social-${idx}`}>
        <S.SocialLink href={link} target="_blank" rel="noopener noreferrer">
          <Icon width={30} height={30} icon={icon} />
        </S.SocialLink>
      </S.SocialItem>
    ))}
  </S.SocialList>
);

SocialLinks.defaultProps = {
  links: []
};

export default memo(SocialLinks);
